import { Check } from 'lucide-react';
import { Pill } from '@/components/ui';
import type { WizardStep } from '../types';

interface StepIndicatorProps {
  step: WizardStep;
  index: number;
  currentStep: number;
  isCompleted: boolean;
  isAccessible: boolean;
  onClick: () => void;
}

/**
 * One step in the wizard's step bar: a kit pill with the step number, a
 * check once the step is complete. The current step announces itself as
 * `aria-current="step"`; steps the user cannot reach yet are disabled.
 * Rendered inside a `PillGroup mode="nav"`.
 */
export function StepIndicator({
  step,
  index,
  currentStep,
  isCompleted,
  isAccessible,
  onClick,
}: StepIndicatorProps) {
  const isActive = index === currentStep;

  return (
    <Pill
      active={isActive}
      disabled={!isAccessible}
      onClick={onClick}
      aria-current={isActive ? 'step' : undefined}
      aria-label={`Step ${index + 1}: ${step.title}`}
    >
      <span
        className={
          isActive
            ? 'inline-flex h-5 w-5 items-center justify-center rounded-pill bg-primary-fg font-mono text-[11px] text-primary'
            : 'inline-flex h-5 w-5 items-center justify-center rounded-pill bg-paper-3 font-mono text-[11px] text-ink-2'
        }
        aria-hidden="true"
      >
        {isCompleted ? <Check className="h-3 w-3" /> : index + 1}
      </span>
      {step.title}
    </Pill>
  );
}
